import React from 'react';

import { noop } from '@/utility/noop';

export type SetSchemeFunction = (scheme: 'light' | 'dark') => void;

export const ColorSchemeContext = React.createContext<SetSchemeFunction>(noop);
export const ColorSchemeValueContext = React.createContext<'light' | 'dark'>('light');
